import { render, staticRenderFns } from "./includeCluesList.vue?vue&type=template&id=c924d44c&scoped=true&"
import script from "./includeCluesList.vue?vue&type=script&lang=js&"
export * from "./includeCluesList.vue?vue&type=script&lang=js&"
import style0 from "./includeCluesList.vue?vue&type=style&index=0&id=c924d44c&lang=less&scoped=true&"
import style1 from "./includeCluesList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c924d44c",
  null
  
)

component.options.__file = "includeCluesList.vue"
export default component.exports